import { render } from "./OurClients.vue?vue&type=template&id=7678973b"
import script from "./OurClients.vue?vue&type=script&lang=js"
export * from "./OurClients.vue?vue&type=script&lang=js"

import "./OurClients.vue?vue&type=style&index=0&id=7678973b&lang=css"

import exportComponent from "/Users/fasa/JS/freelance/UgaldeYAsociados/gerardoyasociados-website-final/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__